import cx from "classnames"
import styles from "./Button.module.scss"
import { ArrowLeft, ArrowRight, Loader } from "react-feather"

const Button = ({
  onClick = () => {},
  children,
  displayType,
  iconPosition,
  disabled,
  className,
  type,
  loading = false,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cx(
        styles.Button,
        {
          [styles.primary]: displayType?.value === "button_primary",
          [styles.secondary]: displayType?.value === "button_secondary",
          [styles.tertiary]: displayType?.value === "button_tertiary",
          [styles.link]: displayType?.value === "link",
          [styles.noPadding]: !children,
          [styles.disabled]: disabled || loading,
        },
        className
      )}
    >
      {iconPosition?.value === "left" && <ArrowLeft className="h-6 w-6" />}
      {children && (
        <span
          className={cx({
            "ml-4": iconPosition?.value === "left",
            "mr-4": iconPosition?.value === "right",
          })}
        >
          {children}
        </span>
      )}
      {iconPosition?.value === "right" && <ArrowRight className="h-6 w-6" />}

      {loading && (
        <div className={styles.loader}>
          <Loader className="h-full aspect-square animate-spin" />
        </div>
      )}
    </button>
  )
}

export default Button
